export const ADMIN_API_URL = process.env.REACT_APP_SAAS_API_URL || 'https://api.mawered.com';
export const TOKEN_KEY = 'superadmin_token';

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);
export const setStoredToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const removeStoredToken = () => localStorage.removeItem(TOKEN_KEY);

export const authFetch = async (url, options = {}) => {
  const token = getStoredToken();
  if (!token) throw new Error('Not authenticated');

  const headers = {
    ...options.headers,
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    removeStoredToken();
    window.location.reload();
    throw new Error('Session expired');
  }

  return response;
};

export const formatDate = (dateStr, short = false, language) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString(language, short
    ? { day: '2-digit', month: 'short', year: 'numeric' }
    : { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }
  );
};
